/** 서버가 주는 타임라인 사건 종류. 수정만 전후 비교(changes)를 싣는다. */
export const HISTORY_EVENT = {
    UPLOADED: 'uploaded',
    CREATED: 'created',
    DRAFT_SAVED: 'draft_saved',
    CONFIRMED: 'confirmed',
    EDITED: 'edited',
    ALLOCATION: 'allocation',
};

/** 타임라인 한 줄의 제목과 점 색. 문서 상태 칩과 같은 색 계열. */
export const EVENT_STYLE = {
    [HISTORY_EVENT.UPLOADED]: { label: 'Uploaded', color: '#0277bd' },
    [HISTORY_EVENT.CREATED]: { label: 'Created', color: '#0277bd' },
    [HISTORY_EVENT.DRAFT_SAVED]: { label: 'Draft saved', color: '#b26a00' },
    [HISTORY_EVENT.CONFIRMED]: { label: 'Confirmed', color: '#2e7d32' },
    [HISTORY_EVENT.EDITED]: { label: 'Edited', color: '#00647e' },
    [HISTORY_EVENT.ALLOCATION]: { label: 'Allocation', color: '#6b7a82' },
};

/** 비교표에 보일 칸 이름. 목록에 없는 칸은 밑줄만 띄어쓰기로 바꾼다. */
const FIELD_LABEL = {
    doc_type: 'Document type',
    invoice_no: 'Invoice No.',
    invoice_date: 'Invoice date',
    po_no: 'PO No.',
    shipper_name: 'Shipper',
    consignee_name: 'Consignee',
    country_of_origin: 'Country of origin',
    asn_no: 'ASN No.',
    total_net_weight: 'Total N.W.',
    total_gross_weight: 'Total G.W.',
    weight_uom: 'Weight unit',
    total_volume: 'Total volume',
    volume_uom: 'Volume unit',
    item_code: 'Item code',
    buyer_sku: 'Buyer SKU',
    style_name: 'Style',
    barcode: 'Barcode',
    description: 'Description',
    description_alt: 'Description (alt)',
    net_weight: 'N.W.',
    gross_weight: 'G.W.',
    volume: 'Volume',
    lot_no: 'Lot No.',
    production_date: 'Production date',
    expiry_date: 'Expiry date',
    cntr_hint: 'Container on PL',
    quantities: 'Quantity',
    line: 'Line',
    alloc_qty: 'Allocated',
};

export const fieldLabel = (field) => FIELD_LABEL[field] ?? String(field ?? '').replace(/_/g, ' ');

/** 비교표의 값 한 칸. 비어 있으면 대시. */
export const formatChangeValue = (value) => {
    if (value === null || value === undefined || value === '') return '—';
    return String(value);
};

/** 담당자 표기. 이름이 없으면 id, 둘 다 없으면 System. */
export const actorName = (by) => by?.name || (by?.id != null ? `User ${by.id}` : 'System');

/** 사건 제목 아래 보이는 한 줄 요약 — 파일명, 라인 수·Invoice, 품목 → 배분 결과. */
export const describeEvent = (event) => {
    const summary = event?.summary ?? {};
    const lines = (n) => `${n ?? 0} line${n === 1 ? '' : 's'}`;
    switch (event?.event) {
        case HISTORY_EVENT.UPLOADED:
            return event.file?.original_filename ? event.file.original_filename : 'Original file';
        case HISTORY_EVENT.CREATED:
            return 'Manual entry';
        case HISTORY_EVENT.DRAFT_SAVED:
            return summary.value || 'Draft saved';
        case HISTORY_EVENT.CONFIRMED:
            return [lines(summary.line_count), summary.invoice_no].filter(Boolean).join(' · ');
        case HISTORY_EVENT.EDITED:
            if (summary.data_changed === false) return 'Re-confirmed — no tracked data change';
            return `Re-confirmed · ${lines(summary.line_count)} · ${changeCount(event)} change${changeCount(event) === 1 ? '' : 's'}`;
        case HISTORY_EVENT.ALLOCATION:
            return [summary.item, summary.value].filter(Boolean).join(' → ');
        default:
            return '';
    }
};

export const changeCount = (event) => (Array.isArray(event?.changes) ? event.changes.length : 0);

/** 전후 비교를 펼칠 수 있는 사건인지(수정). */
export const hasComparison = (event) => Array.isArray(event?.changes) && event.changes.length > 0;

/** 변경 목록을 비교표 묶음(문서 헤더·품목별·배분)으로 나눈다. 추가·삭제 라인은 kind로 표시한다. */
export const groupChanges = (changes = []) => {
    const groups = [];
    const byKey = new Map();
    const group = (key, title) => {
        if (!byKey.has(key)) {
            const g = { key, title, rows: [] };
            byKey.set(key, g);
            groups.push(g);
        }
        return byKey.get(key);
    };
    changes.forEach((c, index) => {
        const row = { key: `${c.scope}:${c.item_id ?? ''}:${c.field}:${c.target_id ?? index}`, label: fieldLabel(c.field), before: c.before, after: c.after, kind: c.kind ?? null };
        if (c.scope === 'document') group('document', 'Document').rows.push(row);
        else if (c.scope === 'item') group(`item:${c.item_id}`, c.item || `Item ${c.item_id}`).rows.push(row);
        else group('allocation', 'Container allocation').rows.push({ ...row, label: `${c.item || `Item ${c.item_id}`} → ${c.target_number || c.target_id}` });
    });
    return groups;
};
